import Text from "@components/AppText";
import React, { memo } from "react";
import { ActivityIndicator, TouchableOpacity, View } from "react-native";

import colors from "@constants/color";

function Button(props) {
  const {
    btnText = "",
    disabled = false,
    buttonColor = colors.primary,
    circleBtn = false,
    iconForCircleBtn = null,
    iconForStdBtn = null,
    iconForStdBtnRight = null,
    buttonWidth = 180,
    textColor,
    borderColor,
    loaderColor = colors.white,
    onPress = () => {},
    fontSize = 16,
    height,
    borderRadius = 16,
    containerStyle = {},
    buttonStyle = {},
    RenderAs = TouchableOpacity,
    iconRightStyles = {},
    buttonFontType = "",
    isSubmitting = false,
    eventName = null,
    eventPayload = {},
    shouldBoldText = true,
    activeOpacity = 0.6,
    disallowClickWhileSubmitting = false,
    textStyle = {},
    IconRight = null,
    fontFamily = "",
    testID = "",
    onDisablePress = () => {},
  } = props;

  const btnContent = () => {
    if (isSubmitting) {
      return <ActivityIndicator size="small" color={loaderColor} />;
    } else {
      const styles = {
        color: textColor || colors.white,
        textAlign: "center",
      };
      // if (buttonFontType) {
      //   styles.fontSize = fontSize;
      // }
      styles.fontSize = fontSize;
      if (fontFamily) styles.fontFamily = fontFamily;

      return (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text
            fontType={buttonFontType}
            style={[{ ...styles }, { ...textStyle }]}
            bold={shouldBoldText}
          >
            {btnText}
          </Text>
          {IconRight || <></>}
        </View>
      );
    }
  };

  return (
    <View style={{ ...containerStyle }}>
      <RenderAs
        testID={testID}
        style={{
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: disabled ? colors.silver : buttonColor,
          minHeight: circleBtn ? 80 : height || 50,
          width: circleBtn ? 80 : buttonWidth,
          borderRadius: circleBtn ? 50 : borderRadius,
          justifyContent: "center",
          borderColor: borderColor || "transparent",
          borderWidth: 1,
          ...buttonStyle,
        }}
        activeOpacity={activeOpacity}
        onPress={() => {
          if (disabled) {
            onDisablePress();
            return;
          }

          if (disallowClickWhileSubmitting && isSubmitting) {
            return;
          }
          onPress();
        }}
        disabled={disabled && !onDisablePress}
        eventName={eventName}
        eventPayload={eventPayload}
      >
        {circleBtn ? (
          iconForCircleBtn
        ) : (
          <View
            style={{
              flex: 1,
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {iconForStdBtn && <View>{iconForStdBtn}</View>}

            <View
              style={{
                marginLeft: iconForStdBtn ? 2 : 0,
                flex: 1,
                marginRight: iconForStdBtnRight ? 2 : 0,
              }}
            >
              {btnContent()}
            </View>

            {iconForStdBtnRight && (
              <View style={iconRightStyles}>{iconForStdBtnRight}</View>
            )}
          </View>
        )}
      </RenderAs>
    </View>
  );
}

export default memo(Button);
